<template>
  <div data-tour-id="samples-register-templates-list-root">
    <div v-if="loadingSamplingTemplates" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>

    <div v-if="showHeader" class="summary-header">
      <div class="summary-title">
        <div class="summary-icon-templates"></div>
        <div class="summary-text">
          {{ $t('TemplatesListTitle') }}
        </div>
      </div>
    </div>

    <div data-tour-id="samples-register-templates-list-grid">
      <DxDataGrid
        :data-source="samplingTemplates"
        :show-borders="false"
        :show-column-lines="false"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-column-headers="true"
        :show-colon="false"
        :remote-operations="false"
        :load-panel="{ enabled: false }"
        :hover-state-enabled="false"
        :show-row-lines="false"
        :row-alternation-enabled="false"
        :no-data-text="$t('noDataText')"
        class="custom-grid custom-templates"
        @content-ready="init"
        @toolbar-preparing="onToolbarPreparing($event)"
        @row-click="onRowClick"
        @row-dbl-click="onRowDoubleClick"
      >
        <DxScrolling mode="standard" />

        <DxStateStoring
          :enabled="true"
          type="custom"
          storage-key="SamplingTemplatesTable"
          :custom-load="loadState"
          :custom-save="customSave"
        />

        <DxPaging :page-size="10" />

        <DxPager
          :show-page-size-selector="true"
          :allowed-page-sizes="[5, 10, 20]"
          :show-info="true"
          info-text="{2} items"
          :visible="true"
        />

        <DxSearchPanel
          :visible="true"
          :width="300"
          :placeholder="$t('search')"
        />

        <DxColumn
          data-field="template.name"
          :caption="$t('templateName')"
          alignment="left"
          :allow-sorting="true"
          :fixed="true"
          fixed-position="left"
          :allow-header-filtering="false"
        />

        <DxColumn
          data-field="template.shortDescription"
          :caption="$t('templateDescription')"
          alignment="left"
          :allow-sorting="true"
          :allow-header-filtering="false"
        />

        <!-- <DxColumn
          data-field="template.active"
          :caption="$t('active')"
          alignment="center"
          cell-template="cellTemplateActive"
          :allow-header-filtering="false"
        /> -->

        <!-- <DxColumn
        data-field="template.isDefault"
        :caption="$t('default')"
        alignment="center"
        cell-template="cellTemplateDefault"
        :allow-header-filtering="false"
        width="150"
      /> -->

        <!-- <DxColumn
        data-field="audit.updatedAt"
        :caption="$t('lastUpdate')"
        alignment="center"
        data-type="date"
        :format="$helpers.getDateFormat(company)"
        sort-order="desc"
        :allow-header-filtering="false"
      /> -->

        <DxColumn
          v-if="showActionColumn"
          :buttons="actionButtons"
          :fixed="true"
          fixed-position="right"
          alignment="center"
          width="240"
          type="buttons"
          name="actionColumn"
        />

        <!-- <template #cellTemplateActive="{ data }">
          <div
            class="template-active-switch"
            @click.stop
            @dblclick.stop
          >
            <DxSwitch
              :value="isTemplateActive(data.data)"
              :disabled="
                loadingSamplingTemplates ||
                isTemplateToggleLoading(data.data)
              "
              @valueChanged="
                (e) => onTemplateActiveSwitchChanged(e, data)
              "
            />
          </div>
        </template> -->

        <template #cellTemplateDefault="{ data }">
          <div
            v-if="isTemplateDefault(data.data)"
            class="template-chip template-chip--default"
          >
            {{ defaultBadgeText }}
          </div>
          <span v-else class="template-chip template-chip--muted">
            {{ noText }}
          </span>
        </template>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxSearchPanel,
  DxStateStoring,
  DxPager,
  DxPaging,
  DxScrolling,
} from 'devextreme-vue/data-grid';
import { DxSwitch } from 'devextreme-vue/switch';
import { mapActions, mapState } from 'vuex';
import { NOTIFY_TIME_LONG } from '@/js/constants';
import iconVisibility from '@/static/icons/ic_visibility.svg';
import iconEdit from '@/static/icons/ic_edit_new.svg';
import iconTrash from '@/static/icons/ic_trash_new.svg';
import iconUpload from '@/static/icons/ic_upload_new.svg';
import iconDocumentTemplate from '@/static/icons/Document.svg';
import { emitSamplesRegisterGa4Event } from '@/services/samplesRegisterAnalytics';

export default {
  name: 'TemplatesList',
  components: {
    DxDataGrid,
    DxColumn,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxPaging,
    DxScrolling,
    DxSwitch,
  },
  props: {
    filters: {
      type: Object,
      default: () => ({
        active: true,
      }),
    },
    autoLoad: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    showActionColumn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      grid: null,
      togglingTemplateIds: {},
    };
  },
  computed: {
    ...mapState('contact', ['company']),
    ...mapState('Offers', ['detallesPresupuestos']),
    ...mapState('samplingTemplatesModule', [
      'samplingTemplates',
      'loadingSamplingTemplates',
    ]),
    ...mapState('samplesRegisterModule', [
      'idInvoice',
      'invoiceCodeInfoPopUp',
      'invoiceSamples',
    ]),
    actionButtons() {
      return [
        {
          icon: iconVisibility,
          hint: this.$t('viewTemplate'),
          onClick: (e) => this.emitSelectTemplate(e),
          cssClass:
            'grid-button-icon samples-register-templates-list-view-button',
        },
        {
          icon: iconEdit,
          hint: this.$t('editTemplate'),
          onClick: (e) => this.onEditTemplateClick(e),
          cssClass:
            'grid-button-icon samples-register-templates-list-edit-button',
        },
        {
          icon: iconUpload,
          hint: this.$t('loadTemplateAndCreateSamples'),
          onClick: (e) => this.onRegisterTemplateClick(e),
          cssClass:
            'grid-button-icon samples-register-templates-list-load-button',
        },
        {
          icon: iconTrash,
          hint: this.$t('deleteTemplate'),
          onClick: (e) => this.onDeleteTemplateClick(e),
          cssClass: 'grid-button-icon',
        },
      ];
    },
    defaultBadgeText() {
      return this.$t('yes') !== 'yes' ? this.$t('yes') : 'Si';
    },
    noText() {
      return this.$t('no') !== 'no' ? this.$t('no') : 'No';
    },
  },
  watch: {
    filters: {
      async handler(value) {
        if (!this.autoLoad) return;
        await this.loadTemplates(value);
      },
      deep: true,
    },
  },
  async mounted() {
    if (this.autoLoad) {
      await this.loadTemplates(this.filters);
    }
  },
  methods: {
    async loadTemplates(filters = {}) {
      try {
        await this.fetchTemplates(filters);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                error?.response || error?.message || error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
    onToolbarPreparing(e) {
      const toolbarItems = e.toolbarOptions.items;
      e.toolbarOptions.elementAttr = {
        class: 'custom-simple-toolbar',
      };

      toolbarItems.forEach((item) => {
        if (item.name === 'searchPanel') {
          item.location = 'before';
        }
      });

      toolbarItems.push({
        name: 'CreateTemplate',
        location: 'after',
        widget: 'dxButton',
        locateInMenu: 'never',
        cssClass: 'templates-list-create-template-button',
        options: {
          text: this.$t('createTemplate'),
          width: 125,
          elementAttr: {
            class: 'botones-registrar',
            'data-tour-id':
              'samples-register-templates-list-create-template-button',
          },
          onClick: () => {
            this.goToExpressRegisterForTemplate();
          },
        },
      });
    },
    loadState() {
      const raw = localStorage.getItem('SamplingTemplatesTable');
      if (!raw) return null;

      const state = JSON.parse(raw);
      state.searchText = '';
      return state;
    },
    customSave(state) {
      localStorage.setItem(
        'SamplingTemplatesTable',
        JSON.stringify(state)
      );
    },
    init(e) {
      this.grid = e.component;
    },
    async goToExpressRegisterForTemplate() {
      try {
        this.$f7.preloader.show();

        if (this.invoiceSamples.length > 0) {
          this.setInvoiceSamples([]);
        }

        await this.RegisterInvoice();

        emitSamplesRegisterGa4Event(
          this,
          'sampling_template_create_start',
          {
            screen_name: 'TemplatesListPage',
            entry_point: 'templates_list_create_template_button',
            register_mode: 'express',
          }
        );

        this.$f7router.navigate(
          {
            name: 'SamplesRegister',
            query: {
              tab: '0',
              mode: 'express',
              source: 'templates-list-create-template',
            },
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                error?.response || error?.message || error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    normalizeString(value) {
      if (value === null || value === undefined) return '';
      return String(value).trim();
    },
    normalizeTemplateText(value) {
      if (value === null || value === undefined) return null;
      if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed.length ? trimmed : null;
      }
      return value;
    },
    getTemplateAnalyticsParams(templateRow, extraParams = {}) {
      const templateData = templateRow?.template || {};

      return {
        template_id: this.getTemplateId(templateRow) || undefined,
        template_name:
          this.normalizeString(templateData?.name) || undefined,
        template_active: this.isTemplateActive(templateRow),
        ...extraParams,
      };
    },
    toNullableNumber(value) {
      if (value === null || value === undefined || value === '') {
        return null;
      }

      const parsed = Number(value);
      return Number.isNaN(parsed) ? null : parsed;
    },
    toBoolean(value, fallback = false) {
      if (typeof value === 'boolean') return value;
      if (typeof value === 'number') return value === 1;
      if (typeof value === 'string') {
        const normalized = value.trim().toLowerCase();
        return (
          normalized === 'true' ||
          normalized === '1' ||
          normalized === 'si' ||
          normalized === 'yes'
        );
      }
      return fallback;
    },
    getCurrentInvoiceId() {
      if (Array.isArray(this.idInvoice)) {
        return this.idInvoice[0] || null;
      }
      return this.idInvoice || null;
    },
    getCurrentInvoiceCode() {
      if (Array.isArray(this.invoiceCodeInfoPopUp)) {
        return this.invoiceCodeInfoPopUp[0] || null;
      }
      return this.invoiceCodeInfoPopUp || null;
    },
    isTemplateToggleLoading(templateRow) {
      const templateId = this.getTemplateId(templateRow);
      if (!templateId) return false;
      return Boolean(this.togglingTemplateIds[templateId]);
    },
    getTemplateActivePayload(templateRow, active) {
      const templateData = templateRow?.template || {};
      return {
        template: {
          id: templateData?.id,
          name: templateData?.name,
          shortDescription: templateData?.shortDescription || '',
          isDefault: Boolean(templateData?.isDefault),
          active: Boolean(active),
        },
      };
    },
    async onTemplateActiveSwitchChanged(event, cellData) {
      const templateRow = cellData?.data || null;
      const templateId = this.getTemplateId(templateRow);

      if (!templateId) return;

      const newState = this.toBoolean(event?.value);
      const currentState = this.isTemplateActive(templateRow);
      if (newState === currentState) return;

      this.$set(this.togglingTemplateIds, templateId, true);

      try {
        if (newState) {
          await this.updateTemplateAction({
            id: templateId,
            data: this.getTemplateActivePayload(
              templateRow,
              newState
            ),
          });
        } else {
          await this.deactivateTemplateAction(templateId);
        }

        emitSamplesRegisterGa4Event(
          this,
          'sampling_template_status_updated',
          this.getTemplateAnalyticsParams(templateRow, {
            screen_name: 'TemplatesListPage',
            entry_point: 'templates_list_active_switch',
            template_active: newState,
          })
        );

        await this.loadTemplates(this.filters);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                error?.response || error?.message || error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );

        if (
          cellData?.component &&
          typeof cellData?.rowIndex === 'number'
        ) {
          cellData.component.repaintRows([cellData.rowIndex]);
        }
      } finally {
        this.$delete(this.togglingTemplateIds, templateId);
      }
    },
    getTemplateBudgetCode(templateData) {
      const budget =
        templateData?.defaults?.codPresupuesto ||
        templateData?.defaults?.CodPresupuesto ||
        null;

      if (!budget) return '';

      if (typeof budget === 'object') {
        return this.normalizeString(
          budget.id ||
            budget.codigo ||
            budget.codPresupuesto ||
            budget.CodPresupuesto
        );
      }

      return this.normalizeString(budget);
    },
    getTemplateSamples(templateData) {
      return Array.isArray(templateData?.samples)
        ? templateData.samples
        : [];
    },
    getTemplateSampleDescription(sample) {
      return this.normalizeString(
        sample?.descripcionMuestra || sample?.DescripcionMuestra
      );
    },
    getTemplateSampleTypeId(sample) {
      return (
        sample?.tipoMuestra?.id ||
        sample?.idTipoMuestra ||
        sample?.Descripcion?.idTipoMuestra ||
        sample?.Descripcion ||
        null
      );
    },
    getTemplateSampleFamilyId(sample) {
      return (
        sample?.familiaTM?.id ||
        sample?.idFamilia ||
        sample?.FamiliaTM ||
        null
      );
    },
    getTemplateSampleArticleId(sample) {
      return this.normalizeString(
        sample?.articulo?.id ||
          sample?.CodArticulo ||
          sample?.codArticulo ||
          sample?.Articulo
      );
    },
    getTemplateSampleBudgetCode(sample) {
      const budget =
        sample?.codPresupuesto || sample?.CodPresupuesto || null;
      if (!budget) return '';

      if (typeof budget === 'object') {
        return this.normalizeString(
          budget?.id ||
            budget?.codigo ||
            budget?.codPresupuesto ||
            budget?.CodPresupuesto
        );
      }

      return this.normalizeString(budget);
    },
    findOfferLineForSample(sample, offerLines = []) {
      const articleId = this.getTemplateSampleArticleId(sample);
      if (!articleId) return null;

      const candidates = offerLines.filter(
        (line) =>
          this.normalizeString(line?.CodArticulo) === articleId
      );
      if (!candidates.length) return null;

      const familyId = this.toNullableNumber(
        this.getTemplateSampleFamilyId(sample)
      );
      if (familyId == null) return candidates[0];

      const byFamily = candidates.find(
        (line) => this.toNullableNumber(line?.IdFamilia) === familyId
      );
      return byFamily || candidates[0];
    },
    getTemplateSamplesBudgetCodes(samples = []) {
      return [
        ...new Set(
          samples
            .map((sample) => this.getTemplateSampleBudgetCode(sample))
            .filter(Boolean)
        ),
      ];
    },
    getDiscountedPrice(offerLine) {
      const gross = Number(offerLine?.PrecioBruto);
      if (Number.isNaN(gross)) return null;

      const discount = Number(offerLine?.Descuento);
      const safeDiscount = Number.isNaN(discount) ? 0 : discount;

      return (
        Math.round((gross - (gross * safeDiscount) / 100) * 10) / 10
      );
    },
    mapTemplateSampleToRegisterPayload(
      sample,
      offerLinesByBudget = {},
      sampleIndex = 0
    ) {
      const description = this.getTemplateSampleDescription(sample);
      const sampleTypeId = this.getTemplateSampleTypeId(sample);
      const articleId = this.getTemplateSampleArticleId(sample);
      const sampleBudgetCode =
        this.getTemplateSampleBudgetCode(sample) ||
        Object.keys(offerLinesByBudget || {})[0] ||
        '';
      const offerLines = Array.isArray(offerLinesByBudget?.[sampleBudgetCode])
        ? offerLinesByBudget[sampleBudgetCode]
        : [];
      const offerLine = this.findOfferLineForSample(
        sample,
        offerLines
      );
      const familyId =
        this.getTemplateSampleFamilyId(sample) ||
        offerLine?.IdFamilia ||
        null;

      if (!description || !sampleTypeId || !articleId || !offerLine) {
        throw new Error(
          `template_missing_required_data_${sampleIndex + 1}`
        );
      }

      const automaticSamplingPoint = this.toBoolean(
        sample?.automaticSamplingPoint,
        true
      );
      const farmId = automaticSamplingPoint
        ? sample?.finca?.id || sample?.Parcelas || sample?.idFinca
        : null;
      const plotId = automaticSamplingPoint
        ? sample?.parcela?.id || sample?.Parcela || sample?.idParcela
        : null;
      const levelPointId =
        sample?.nivelPunto?.id ||
        sample?.idNivelPunto ||
        sample?.IdNivelPunto ||
        null;

      return {
        DescripcionMuestra: description,
        FamiliaTM: familyId,
        idTipoMuestra: sampleTypeId,
        Descripcion: {
          idTipoMuestra: sampleTypeId,
        },
        SubTipoMuestra:
          sample?.subTipoMuestra?.id ||
          sample?.idSubTipoMuestra ||
          sample?.SubTipoMuestra ||
          null,
        Articulo: articleId,
        CodPresupuesto: sampleBudgetCode || null,
        CodLinea: offerLine.CodLinea,
        idSubFamiliaTM:
          offerLine.IdSubFamilia || offerLine.IdSubFamiliaTM || null,
        PrecioAT: this.getDiscountedPrice(offerLine),
        Descuento: offerLine.Descuento ?? null,
        automaticSamplingPoint,
        Parcelas: farmId,
        FincaLiteral: automaticSamplingPoint
          ? null
          : this.normalizeString(
              sample?.fincaLiteral ||
                sample?.FincaLiteral ||
                sample?.finca?.descripcion
            ) || null,
        Parcela: plotId,
        ParcelaLiteral: automaticSamplingPoint
          ? null
          : this.normalizeString(
              sample?.parcelaLiteral ||
                sample?.ParcelaLiteral ||
                sample?.parcela?.descripcion
            ) || null,
        idNivelPunto: levelPointId || 0,
        cma: this.toBoolean(sample?.cma),
        lmr: this.toBoolean(sample?.lmr),
        trazaCultivo: this.toBoolean(sample?.trazaCultivo),
        CultivoOrganico: this.toBoolean(sample?.cultivoOrganico),
        Legislacion:
          sample?.legislacion?.id ||
          sample?.idLegislacion ||
          sample?.Legislacion ||
          null,
        Observaciones:
          this.normalizeString(
            sample?.observaciones || sample?.Observaciones
          ) || null,
        lote:
          this.normalizeString(sample?.lote || sample?.LoteCodigo) ||
          null,
        cloroResidual:
          sample?.cloroResidual || sample?.CloroResidualLibre || null,
      };
    },
    getTemplateSamplingDate(templateData) {
      const samplingDate =
        templateData?.defaults?.samplingDate ||
        templateData?.defaults?.SamplingDate ||
        null;
      if (!samplingDate) return new Date();

      const parsedDate = new Date(samplingDate);
      return Number.isNaN(parsedDate.getTime())
        ? new Date()
        : parsedDate;
    },
    getTemplateSampler(templateData) {
      const sampler =
        templateData?.defaults?.sampler ||
        templateData?.defaults?.Sampler ||
        null;
      return this.normalizeString(sampler) || null;
    },
    getTemplateClientCode(templateData) {
      return (
        this.normalizeString(
          templateData?.defaults?.codCliente ||
            templateData?.defaults?.CodCliente ||
            this.company
        ) || null
      );
    },
    mapTemplateSampleForDraft(sample, index) {
      return {
        ...sample,
        order: sample?.order || index + 1,
        descripcionMuestra:
          this.normalizeTemplateText(
            sample?.descripcionMuestra ?? sample?.DescripcionMuestra
          ) || '',
        observaciones:
          this.normalizeTemplateText(
            sample?.observaciones ?? sample?.Observaciones
          ) || '',
        cma: this.toBoolean(sample?.cma),
        lmr: this.toBoolean(sample?.lmr),
        trazaCultivo: this.toBoolean(sample?.trazaCultivo),
        cultivoOrganico: this.toBoolean(
          sample?.cultivoOrganico ?? sample?.CultivoOrganico
        ),
      };
    },
    buildTemplateEditDraft(templateData) {
      const templateId = this.getTemplateId(templateData);
      const currentTemplateData = templateData?.template || {};
      const templateSamples = Array.isArray(templateData?.samples)
        ? templateData.samples
        : [];

      return {
        ...(templateData || {}),
        template: {
          ...currentTemplateData,
        },
        samples: templateSamples.map((sample, index) =>
          this.mapTemplateSampleForDraft(sample, index)
        ),
        sourceRouteName: 'TemplatesListPage',
        editingTemplateId: templateId,
      };
    },
    async onEditTemplateClick(e) {
      const templateRow = e?.row?.data || null;
      const templateId = this.getTemplateId(templateRow);

      if (!templateId) return;

      try {
        this.$f7.preloader.show();
        const templateData = await this.fetchTemplate(templateId);
        const draft = this.buildTemplateEditDraft(templateData);

        if (!draft?.editingTemplateId) {
          throw new Error('template_edit_not_ready');
        }

        emitSamplesRegisterGa4Event(
          this,
          'sampling_template_create_open',
          this.getTemplateAnalyticsParams(templateRow, {
            screen_name: 'TemplateCreatePage',
            entry_point: 'templates_list_edit_button',
            template_mode: 'edit',
          })
        );

        this.setTemplateCreationDraft(draft);
        this.$f7router.navigate(
          {
            name: 'TemplateCreatePage',
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                error?.response || error?.message || error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    async onRegisterTemplateClick(e) {
      const templateRow = e?.row?.data || null;
      const templateId = this.getTemplateId(templateRow);
      if (!templateId) return;

      let createdInvoiceId = null;
      let registrationRequested = false;

      try {
        this.$f7.preloader.show();

        const templateData = await this.fetchTemplate(templateId);
        const templateSamples = this.getTemplateSamples(templateData);
        const templateSampleBudgetCodes =
          this.getTemplateSamplesBudgetCodes(templateSamples);
        const budgetCode =
          this.getTemplateBudgetCode(templateData) ||
          templateSampleBudgetCodes[0] ||
          '';
        const registerBudgetCode =
          this.getTemplateSampleBudgetCode(
            templateSamples[templateSamples.length - 1]
          ) ||
          budgetCode;
        const sampleBudgetCodes = templateSampleBudgetCodes.length
            ? templateSampleBudgetCodes
            : budgetCode
            ? [budgetCode]
            : [];

        if (!templateSamples.length || !sampleBudgetCodes.length) {
          throw new Error('template_missing_required_data');
        }

        const offerLinesByBudget = {};
        for (const currentBudgetCode of sampleBudgetCodes) {
          await this.fetchDetallesPresupuestos(currentBudgetCode);
          const currentOfferLines = Array.isArray(
            this.detallesPresupuestos
          )
            ? [...this.detallesPresupuestos]
            : [];

          if (!currentOfferLines.length) {
            throw new Error('template_missing_required_data');
          }

          offerLinesByBudget[currentBudgetCode] = currentOfferLines;
        }

        await this.RegisterInvoice();

        const idInvoice = this.getCurrentInvoiceId();
        const codAlbaran = this.getCurrentInvoiceCode();
        if (!idInvoice || !codAlbaran) {
          throw new Error('invoice_not_created');
        }
        createdInvoiceId = idInvoice;

        const payloadSamples = templateSamples.map((sample, index) =>
          this.mapTemplateSampleToRegisterPayload(
            sample,
            offerLinesByBudget,
            index
          )
        );

        const codCliente = this.getTemplateClientCode(templateData);
        if (!codCliente) {
          throw new Error('template_missing_required_data');
        }

        this.setOfferSelected(registerBudgetCode);

        registrationRequested = true;
        await this.registerInvoiceSamples({
          isExpressMode: true,
          CodCliente: codCliente,
          idAlbaran: idInvoice,
          CodAlbaran: codAlbaran,
          CodPresupuesto: registerBudgetCode,
          Sampler: this.getTemplateSampler(templateData),
          SamplingDate: this.getTemplateSamplingDate(templateData),
          MuestrasExpress: payloadSamples,
        });

        await this.fetchInvoiceSamples(idInvoice);
        emitSamplesRegisterGa4Event(
          this,
          'sampling_template_load_success',
          {
            screen_name: 'SamplesRegister',
            entry_point: 'templates_list_load_button',
            template_id: templateId,
            template_name:
              this.normalizeString(templateData?.template?.name) ||
              undefined,
            samples_count: payloadSamples.length,
            budget_code: registerBudgetCode || undefined,
            register_mode: 'express',
            invoice_id: idInvoice || undefined,
          }
        );
        this.$f7.preloader.hide();
        this.setConfirmPopup(true);

        this.$f7router.navigate(
          {
            name: 'SamplesRegister',
            query: {
              tab: '0',
              mode: 'express',
              source: 'template',
            },
          },
          {
            animate: true,
            transition: 'f7-fade',
          }
        );
      } catch (error) {
        if (createdInvoiceId && !registrationRequested) {
          try {
            await this.deleteInvoice({
              idInvoice: createdInvoiceId,
              deleteSource: 'templates_list_cleanup',
            });
          } catch (cleanupError) {
            console.warn(
              'Unable to rollback invoice created from templates list',
              cleanupError
            );
          }
        }

        const missingFieldsError =
          String(error?.message || '').includes(
            'template_missing_required_data'
          ) ||
          String(error?.message || '').includes(
            'invoice_not_created'
          );

        this.$notifyDX(
          {
            message: missingFieldsError
              ? this.$t('samplesRegister.missingFieldsError')
              : this.$t(
                  this.$helpers.getFilteredErrorMessage(
                    error?.response || error?.message || error
                  )
                ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    async openTourTemplateDetails() {
      const visibleRows =
        typeof this.grid?.getVisibleRows === 'function'
          ? this.grid.getVisibleRows()
          : [];
      const visibleTemplates = visibleRows
        .filter((row) => row?.rowType === 'data')
        .map((row) => row?.data)
        .filter(Boolean);

      const firstVisibleTemplate = visibleTemplates.find((template) =>
        Boolean(this.getTemplateId(template))
      );
      const firstStoreTemplate = Array.isArray(this.samplingTemplates)
        ? this.samplingTemplates.find((template) =>
            Boolean(this.getTemplateId(template))
          )
        : null;
      const firstTemplate =
        firstVisibleTemplate || firstStoreTemplate;
      const templateId = this.getTemplateId(firstTemplate);

      if (!templateId) {
        return {
          opened: false,
        };
      }

      try {
        this.$f7.preloader.show();
        await this.fetchTemplate(templateId);
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                error?.response || error?.message || error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
        return {
          opened: false,
        };
      } finally {
        this.$f7.preloader.hide();
      }

      this.$f7router.navigate(
        {
          name: 'TemplateDetailsPage',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );

      return {
        opened: true,
      };
    },
    emitSelectTemplate(e) {
      const templateRow = e?.row?.data || e || null;
      if (!templateRow) return;

      emitSamplesRegisterGa4Event(
        this,
        'sampling_template_details_open',
        this.getTemplateAnalyticsParams(templateRow, {
          screen_name: 'TemplateDetailsPage',
          entry_point: 'templates_list_view_button',
        })
      );

      this.$emit('select-template', templateRow);
    },
    isTemplateActive(template) {
      return Boolean(
        template && template.template && template.template.active
      );
    },
    isTemplateDefault(template) {
      return Boolean(
        template && template.template && template.template.isDefault
      );
    },
    onRowClick(e) {
      this.$emit('row-click', e.data);
    },
    onRowDoubleClick(e) {
      const templateRow = e?.data || null;
      if (!templateRow) return;

      emitSamplesRegisterGa4Event(
        this,
        'sampling_template_details_open',
        this.getTemplateAnalyticsParams(templateRow, {
          screen_name: 'TemplateDetailsPage',
          entry_point: 'templates_list_row_double_click',
        })
      );

      this.$emit('select-template', templateRow);
    },
    getTemplateId(templateRow) {
      return templateRow?.template?.id || templateRow?.id || null;
    },
    async onDeleteTemplateClick(e) {
      const templateRow = e?.row?.data || null;
      const templateId = this.getTemplateId(templateRow);

      if (!templateId) return;

      try {
        this.$f7.preloader.show();
        await this.removeTemplate(templateId);
        emitSamplesRegisterGa4Event(
          this,
          'sampling_template_delete',
          this.getTemplateAnalyticsParams(templateRow, {
            screen_name: 'TemplatesListPage',
            entry_point: 'templates_list_delete_button',
          })
        );
        await this.loadTemplates(this.filters);

        this.$notifyDX(
          {
            message: this.$t('templateDeletedSuccess'),
            width: 550,
          },
          'success',
          NOTIFY_TIME_LONG
        );
      } catch (error) {
        this.$notifyDX(
          {
            message: this.$t(
              this.$helpers.getFilteredErrorMessage(
                error?.response || error?.message || error
              )
            ),
            width: 550,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      } finally {
        this.$f7.preloader.hide();
      }
    },
    ...mapActions('samplingTemplatesModule', {
      fetchTemplates: 'fetchTemplates',
      fetchTemplate: 'fetchTemplate',
      removeTemplate: 'deleteTemplate',
      updateTemplateAction: 'updateTemplate',
      deactivateTemplateAction: 'deactivateTemplate',
      setTemplateCreationDraft: 'setTemplateCreationDraft',
    }),
    ...mapActions('Offers', ['fetchDetallesPresupuestos']),
    ...mapActions('samplesRegisterModule', [
      'RegisterInvoice',
      'registerInvoiceSamples',
      'fetchInvoiceSamples',
      'setConfirmPopup',
      'setOfferSelected',
      'setInvoiceSamples',
      'deleteInvoice',
    ]),
  },
};
</script>

<style lang="scss">
@import './templates-list.styles.scss';
</style>
